import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const StoryTypeForm = ({ onCancel, getAllStoryTypes, initialData }) => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors, isDirty },
  } = useForm({
    defaultValues: {
      ...initialData,
    }
  });
  const [isLoading, setIsLoading] = useState(false);
   const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);

 
  const durationRanges = [
    "0-90s",
    "91s-3m",
    "3-5min",
    "5-10min",
    "10min+",
  ];
  const shortsCountOptions = ["0","1", "2", "3", "4", "5"];

  const onSubmit = async (data) => {
    if(!isDirty){
      return;
    }
    setIsLoading(true);
    try {
      if(initialData?._id){
        await axios.put(
          `${process.env.REACT_APP_API_URL}/update-story-type/${initialData._id}`,
          data,
          {
            withCredentials: true,
          },
        );
        setSuccessMessage("Story Type Updated!");
      }
      else{
      await axios.post(
        `${process.env.REACT_APP_API_URL}/create-story-type`,
        data,
        {
          withCredentials: true,
        },
      );
      setSuccessMessage("Story Type Created!");
    }

      await getAllStoryTypes();
      setTimeout(() => {
        setSuccessMessage(null);
        onCancel();
      }, 2000);
      reset();



    } catch (err) {
      setErrorMessage(`${err?.response?.data?.message || "An unexpected error occurred."}`);
      setTimeout(() => {
        setErrorMessage(null);
      }, 2000);
    } finally {
      setIsLoading(false);
    }
  };

  const closeModal = () => {
    onCancel();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      {successMessage && (
          <div className="absolute top-0 left-0 right-0 bg-green-500 text-white text-center py-2 rounded-t-lg animate-pulse">
            <div className="flex items-center justify-center">
              <svg 
                className="w-6 h-6 mr-2" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" 
                />
              </svg>
              {successMessage}
            </div>
          </div>
        )}
        {errorMessage && (
  <div className="absolute top-0 left-0 right-0 bg-red-500 text-white text-center py-2 rounded-t-lg animate-pulse">
    <div className="flex items-center justify-center">
      <svg 
        className="w-6 h-6 mr-2" 
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M12 8v4m0 4h.01M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z" 
        />
      </svg>
      {errorMessage}
    </div>
  </div>
)}
      <div className="bg-white rounded-lg shadow-lg w-96">
        {/* Modal Header */}
        <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-lg font-semibold text-gray-800">
          {initialData ? "Edit Story Type" : "Create Story Type"}
          </h2>
          <button
            onClick={closeModal}
            className="text-gray-500 hover:text-gray-800"
          >
            &times;
          </button>
        </div>

        {/* Modal Content */}
        <div className="p-6">
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            {/* Content Type Select */}
            <div className="space-y-2">
              <label
                htmlFor="type"
                className="block text-sm font-medium text-gray-700"
              >
                Content Type
              </label>
              <input
    type="text"
    className={`w-full px-3 py-2 border rounded-md outline-none focus:ring-2 focus:ring-blue-500 ${
      errors.storyType ? "border-red-500" : "border-gray-300"
    }`}
    {...register("name", { 
      required: "Story style is required", 
      pattern: {
        value: /^[A-Z_]+$/,
        message: "Only uppercase letters (A-Z) and underscores (_) are allowed"
      }
    })}
  />
   {errors.name && (
                <p className="mt-1 text-sm text-red-500">
                  {errors.name.message}
                </p>
              )}
            </div>

            <div>
              <label className="block mb-1.5 text-sm font-medium">
                Duration Range
              </label>
              <select
                className="w-full px-3 py-2 border border-gray-300 rounded-md outline-none focus:ring-2 focus:ring-blue-500 appearance-none bg-white"
                {...register("durationRange", {
                  required: "Duration range is required",
                })
                  
                }
              >
                {durationRanges.map((range) => (
                  <option key={range} value={range}>
                    {range}
                  </option>
                ))}
              </select>
              {errors.durationRange && (
                <p className="mt-1 text-sm text-red-500">
                  {errors.durationRange.message}
                </p>
              )}
            </div>

            <div>
              <label className="block mb-1.5 text-sm font-medium">
                Shorts Eligible Count
              </label>
              <select
                className="w-full px-3 py-2 border border-gray-300 rounded-md outline-none focus:ring-2 focus:ring-blue-500 appearance-none bg-white"
                {...register("shortEligibleCount", {
                  required: "Shorts eligible count is required",
                })}
              >
                {shortsCountOptions.map((count) => (
                  <option key={count} value={count}>
                    {count}
                  </option>
                ))}
              </select>
              {errors.shortEligibleCount && (
                <p className="mt-1 text-sm text-red-500">
                  {errors.shortEligibleCount.message}
                </p>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isLoading}
              className={`w-full px-4 py-2 text-white rounded-md transition-colors duration-200 ${isLoading ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"}`}
            >
              {isLoading ? "Submitting..." : "Submit"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StoryTypeForm;
